import React, { useContext, useMemo, useRef } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import DrawerItem from "components/Shared/MSidebar/DrawerItem";
import context from "components/Shared/MSidebar/utility/context";
import { TooltipContext, getTooltipRef } from "components/Shared/TooltipProvider";
import { DIRECT_SEARCH_PREFIXES } from "components/Shared/directSearchPrefixes";

const DrawerSearch = () => {
  const {openSidebar, open, searchText, onSearchChange, search} = useContext(context);
  const tooltipContext = useContext(TooltipContext);
  const inputRef = useRef();

  const tooltipContents = useMemo(() => (
    <div>
      <div><b>Direct search prefixes</b></div>
      {DIRECT_SEARCH_PREFIXES.map(({ prefix, description, example }) => (
        <div key={prefix}>
          <b>{prefix}:</b> {description} ({example})
        </div>
      ))}
    </div>
  ), []);

  const tooltipRef = useMemo(
    () => getTooltipRef(tooltipContents, tooltipContext),
    [tooltipContents, tooltipContext]
  );

  return (
    <div onClick={() => {
      openSidebar(true);
      inputRef.current.focus();
    }}>
      <DrawerItem
        icon={"search"}
        iconOnClick={search}
      >
        <TextField
          {...{inputRef}}
          onChange={({target: {value}}) => onSearchChange(value)}
          onKeyDown={(e => {
            if(e.key === "Enter") {
              e.preventDefault();
              search();
            }
          })}
          value={searchText}
          autoFocus={open}
          className={"DrawerSearch-TextField"}
          placeholder={"Search"}
          fullWidth
          variant="standard"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span ref={tooltipRef}>
                  <IconButton
                    size="small"
                    className="DrawerSearch-HelpIconButton"
                    tabIndex={-1}
                    aria-label="Show direct search options"
                  >
                    <i className="material-icons DrawerSearch-HelpIcon">help</i>
                  </IconButton>
                </span>
              </InputAdornment>
            ),
          }}
        />
      </DrawerItem>
    </div>
  );
};

export default DrawerSearch;